<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

@if (EstCharge()) {
	<div class="ajout-bon-travail-page">
		<p-card styleClass="ajout-bon-travail-card">
			<div class="flex flex-column md:flex-row md:align-items-center gap-2 mb-4">
				<h5 class="mb-0">Soumission de bon de travail</h5>
				<span class="statut nouveau">Nouveau</span>
			</div>

			<div class="fluid formgrid grid">
				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="typeBonTravail">Type</label>
					<p-selectButton
						inputId="typeBonTravail"
						styleClass="type-bon-travail-select w-full md:w-auto"
						[options]="typesBonTravail"
						[(ngModel)]="selectionTypeBonTravail"
						(onChange)="surChangementTypeBonTravail()"
						optionLabel="valeur" />
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="uniteSelectionnee">Unité</label>
					<app-affichage-unite-item
						[item]="bonTravail.item"
						[editable]="changementUnitePermis"
						(edit)="rechercherUnite()" />

					@if (dernierBonTravailRecent) {
						<p-message severity="warn" styleClass="w-full mt-2" [text]="texteDernierBonTravailRecent"></p-message>
					}
					<small class="p-error" *ngIf="submitted && !bonTravail.item?.itemId">L'unité est obligatoire.</small>
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="dateBonTravail">Date<span class="requis">*</span></label>
					<p-calendar
						inputId="dateBonTravail"
						appendTo="body"
						showIcon="true"
						[(ngModel)]="bonTravail.dateTravail"
						dateFormat="yy-mm-dd"
						[yearNavigator]="true"
						[monthNavigator]="true"
						yearRange="2000:2040" />
					<small class="p-error" *ngIf="submitted && !bonTravail.dateTravail">La date est obligatoire.</small>
				</div>
				<div class="hidden md:block md:col-6 mb-3" aria-hidden="true"></div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="raisonBonTravail">Raison<span class="requis">*</span></label>
					<p-dropdown
						inputId="raisonBonTravail"
						[options]="raisons"
						[(ngModel)]="bonTravail.raison"
						optionLabel="description"
						[showClear]="!modeConsultation()"
						filter="true"
						filterBy="code,description"
						appendTo="body"
						placeholder="Sélectionner une raison…">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="bonTravail.raison" class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ bonTravail.raison.code | valeurVide }}</span>
								<span class="text-sm">{{ bonTravail.raison.description | valeurVide }}</span>
							</div>
						</ng-template>
						<ng-template let-raison pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ raison.code | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ raison.description | valeurVide }}</span>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !bonTravail.raison">La raison est obligatoire.</small>
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="contreMaitreBonTravail">Contre-maître<span class="requis">*</span></label>
					<p-dropdown
						inputId="contreMaitreBonTravail"
						[options]="listeEmployes"
						[(ngModel)]="bonTravail.contreMaitre"
						optionLabel="nom"
						[showClear]="true"
						filter="true"
						filterBy="prenomNom,prenom,nom,noEmploye,initiales"
						appendTo="body"
						placeholder="Sélectionner un contre-maître…">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="bonTravail.contreMaitre" class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ bonTravail.contreMaitre.noEmploye | valeurVide }}</span>
								<span class="text-sm">{{ bonTravail.contreMaitre.prenom }} {{ bonTravail.contreMaitre.nom }}</span>
							</div>
						</ng-template>
						<ng-template let-employe pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ employe.noEmploye | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ employe.prenom }} {{ employe.nom }}</span>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !bonTravail.contreMaitre">Le contre-maître est obligatoire.</small>
				</div>

				@if (selectionTypeBonTravail.cle == 1) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<label for="mecanicienBonTravail">Mécanicien</label>
						<p-dropdown
							inputId="mecanicienBonTravail"
							[options]="listeEmployes"
							[(ngModel)]="bonTravail.mecanicien"
							optionLabel="nom"
							[showClear]="true"
							filter="true"
							filterBy="prenomNom,prenom,nom,noEmploye,initiales"
							appendTo="body"
							placeholder="Sélectionner un mécanicien…">
							<ng-template pTemplate="selectedItem">
								<div *ngIf="bonTravail.mecanicien" class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ bonTravail.mecanicien.noEmploye | valeurVide }}</span>
									<span class="text-sm">{{ bonTravail.mecanicien.prenom }} {{ bonTravail.mecanicien.nom }}</span>
								</div>
							</ng-template>
							<ng-template let-employe pTemplate="item">
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ employe.noEmploye | valeurVide }}</span>
									<span class="text-sm text-color-secondary">{{ employe.prenom }} {{ employe.nom }}</span>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				}

				@if (selectionTypeBonTravail.cle == 2) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<label for="fournisseurBonTravail">Fournisseur</label>
						<p-dropdown
							inputId="fournisseurBonTravail"
							[options]="fournisseurs"
							[(ngModel)]="bonTravail.fournisseur"
							optionLabel="nom"
							[showClear]="!modeConsultation()"
							filter="true"
							filterBy="numero,nom"
							appendTo="body"
							placeholder="Sélectionner un fournisseur…">
							<ng-template pTemplate="selectedItem">
								<div *ngIf="bonTravail.fournisseur" class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ bonTravail.fournisseur.numero | valeurVide }}</span>
									<span class="text-sm">{{ bonTravail.fournisseur.nom | valeurVide }}</span>
								</div>
							</ng-template>
							<ng-template let-fournisseur pTemplate="item">
								<div class="flex flex-column gap-1 py-1">
									<span class="font-bold">{{ fournisseur.numero | valeurVide }}</span>
									<span class="text-sm text-color-secondary">{{ fournisseur.nom | valeurVide }}</span>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				}

				<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
					<label for="emplacementBonTravail">Emplacement</label>
					<p-dropdown
						inputId="emplacementBonTravail"
						[options]="emplacements"
						[(ngModel)]="bonTravail.emplacement"
						optionLabel="nom"
						[showClear]="true"
						filter="true"
						filterBy="code,nom"
						appendTo="body"
						placeholder="Sélectionner un emplacement…">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="bonTravail.emplacement" class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ bonTravail.emplacement.code | valeurVide }}</span>
								<span class="text-sm">{{ bonTravail.emplacement.nom | valeurVide }}</span>
							</div>
						</ng-template>
						<ng-template let-emplacement pTemplate="item">
							<div class="flex flex-column gap-1 py-1">
								<span class="font-bold">{{ emplacement.code | valeurVide }}</span>
								<span class="text-sm text-color-secondary">{{ emplacement.nom | valeurVide }}</span>
							</div>
						</ng-template>
					</p-dropdown>
				</div>

				<div class="sihc-field flex flex-column gap-2 col-12 mb-3">
					<label for="noteBonTravail">Note</label>
					<textarea
						id="noteBonTravail"
						pInputTextarea
						[rows]="4"
						[(ngModel)]="bonTravail.note"
						autocomplete="off"
						placeholder="Ajouter une note…"
						class="w-full"></textarea>
				</div>

				@if (bonTravail.item?.itemId) {
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<app-releve-bt-selector
							[itemId]="bonTravail.item.itemId"
							type="heure"
							cote="debut"
							[(valeur)]="bonTravail.heuresDebutCompteur"
							[placeholder]="bonTravail.item.heuresCompteur"
							[releveLie]="bonTravail.releveHeureDebut"
							(releveLieChange)="surReleveDebutHeureChange($any($event))" />
					</div>
					<div class="sihc-field flex flex-column gap-2 col-12 md:col-6 mb-3">
						<app-releve-bt-selector
							[itemId]="bonTravail.item.itemId"
							type="km"
							cote="debut"
							[(valeur)]="bonTravail.kmDebutCompteur"
							[placeholder]="bonTravail.item.kmCompteur"
							[releveLie]="bonTravail.releveKmDebut"
							(releveLieChange)="surReleveDebutKmChange($any($event))" />
					</div>
				}
			</div>
		</p-card>

		<app-creation-confirm-bar
			label="Créer le bon de travail"
			loadingLabel="Création…"
			icon="pi pi-save"
			[loading]="creationEnCours"
			(confirm)="CreerBonTravail()" />
	</div>
}
